"use strict";
exports.__esModule = true;
var angular = require("angular");
require('./onboarding.component.css');
var COMPONENT_NAME = 'smartorg.onboarding';
var OnboardingComponent = /** @class */ (function () {
    function OnboardingComponent() {
        this.videos = {
            overview: {
                pm: 101,
                to: 102
            },
            diff: {
                pa: 201,
                pw: 202,
                qua: 203
            },
            big: {
                af: 301,
                jf: 302,
                ra: 303,
                ms: 304,
                sm: 305
            }
        };
        this.playing = this.videos.overview.pm;
    }
    OnboardingComponent.prototype.playVideo = function (videoId) {
        this.playing = videoId;
    };
    return OnboardingComponent;
}());
angular.module(COMPONENT_NAME, []).component('onboarding', {
    template: require('./onboarding.component.html'),
    controller: OnboardingComponent,
    bindings: {}
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=onboarding.component.js.map


// WEBPACK FOOTER //
// ./app/components/onboarding/onboarding.component.js